// ⌘K command palette (IA §50): Projects, Flows, Assets, Brands — open directly, no hierarchy walk.
import { html, mount, esc } from '../lib/dom';
import { openModal } from './modal';
import { icon } from './icons';
import { assetThumb, coverThumb } from './thumb';
import { search, resolveEntity } from '../api/search';
import * as store from '../store/ui';

const ACTIONS = [
  ['Go to Home', '#/', 'home'], ['Go to Projects', '#/projects', 'projects'], ['Go to Assets', '#/assets', 'archive'],
  ['Go to Brands', '#/brands', 'brands'], ['Go to Runs', '#/runs', 'runs'], ['Failed runs', '#/runs?status=failed', 'alert'],
  ['Gallery', '#/gallery', 'gallery'], ['Marketplace', '#/marketplace', 'tag'], ['Sell a flow', '#/marketplace?tab=selling', 'tag'], ['Organization settings', '#/settings', 'settings'],
];

function itemThumb(it?: any) {
  if (it.kind === 'asset' || it.kind === 'work') return assetThumb(it.entity);
  if (it.kind === 'project' || it.kind === 'brand' || it.kind === 'listing') return coverThumb(it.entity);
  return html`<span class="thumb" style="display:grid;place-items:center">${icon(it.kind === 'flow' ? 'node' : it.icon || 'chevron')}</span>`;
}

export function openPalette() {
  if (document.querySelector('[data-palette]')) return;
  let sel = 0;
  let flat: any[] = [];
  openModal({
    bare: true, wide: true, label: 'Search',
    body: html`<div data-palette><input class="palette-input" placeholder="Search projects, flows, assets, brands…" autofocus aria-label="Search"><div class="palette-list" role="listbox"></div>
      <div class="modal-foot" style="justify-content:space-between"><span class="mono muted" style="font-size:11px">↑↓ navigate · ↵ open · esc close</span><span class="mono muted" style="font-size:11px">Searches the whole Organization</span></div></div>`,
    onMount(modal?: any, close?: any) {
      const input = modal.querySelector('input');
      const list = modal.querySelector('.palette-list');
      const draw = () => {
        const q = input.value;
        let groups;
        if (!q.trim()) {
          const recents = (store.get().recents || []).slice(0, 6).map((r?: any) => {
            const e = resolveEntity(r.entity_type, r.entity_id);
            if (!e) return null;
            const href = r.entity_type === 'flow' ? `#/projects/${e.project_id}/flows/${e.id}` : r.entity_type === 'asset' ? `#/assets/${e.id}` : `#/${r.entity_type}s/${e.id}`;
            return { kind: r.entity_type, title: e.name, sub: r.entity_type, href, entity: e };
          }).filter(Boolean);
          groups = [['Recent', recents], ['Jump to', ACTIONS.map(([title, href, ico]: any) => ({ kind: 'action', title, href, icon: ico, sub: '' }))]];
        } else {
          groups = search(q);
        }
        flat = groups.flatMap(([, items]: any) => items);
        sel = Math.min(sel, Math.max(flat.length - 1, 0));
        let i = -1;
        mount(list, groups.length ? groups.map(([label, items]: any) => html`<div class="menu-label">${label}</div>${items.map((it?: any) => { i++; return html`<a class="palette-item ${i === sel ? 'sel' : ''}" href="${it.href}" data-i="${i}" role="option">${itemThumb(it)}<div class="col" style="gap:1px;flex:1;min-width:0"><span class="ellipsis">${it.title}</span><span class="mono muted ellipsis" style="font-size:11px">${it.sub}</span></div>${icon('chevron')}</a>`; })}`) : html`<div class="empty">No results for “${q}”</div>`);
        list.querySelector('.sel')?.scrollIntoView({ block: 'nearest' });
      };
      input.addEventListener('input', () => { sel = 0; draw(); });
      input.addEventListener('keydown', (e?: any) => {
        if (e.key === 'ArrowDown') { sel = Math.min(sel + 1, flat.length - 1); draw(); e.preventDefault(); }
        if (e.key === 'ArrowUp') { sel = Math.max(sel - 1, 0); draw(); e.preventDefault(); }
        if (e.key === 'Enter' && flat[sel]) {
          e.preventDefault();
          e.stopPropagation();
          const href = flat[sel].href.slice(1);
          close();
          location.hash = href;
        }
      });
      list.addEventListener('mousemove', (e?: any) => { const a = e.target.closest('[data-i]'); if (a && +a.dataset.i !== sel) { sel = +a.dataset.i; list.querySelectorAll('.palette-item').forEach((x?: any) => x.classList.toggle('sel', +x.dataset.i === sel)); } });
      list.addEventListener('click', (e?: any) => { if (e.target.closest('a')) close(); });
      draw();
    },
  });
}
export { esc };
